import PropTypes from 'prop-types';
import React from 'react';
import {
  addError,
  removeError,
  getPayeeErrorInitialState,
  checkErrored,
  listErrors,
  updateParentErrorState,
} from 'react/jaffe/components/forms/PayeeErrors';
import { formatSSN, formatEIN } from 'react/shared/components/dashboard/payee/util';
import PALETTE from 'react/shared/theme/palette';
import bindAll from 'react/shared/utils/bind_all';

export default class PayeeTaxIdInput extends React.Component {
  constructor(props) {
    super(props);
    const initialTaxIdType = this.props.taxIdType || '';
    let initialTaxIdNumber = this.props.taxIdNumber || '';
    if (initialTaxIdType === 'ssn') {
      initialTaxIdNumber = formatSSN(initialTaxIdNumber);
    } else if (initialTaxIdType === 'ein') {
      initialTaxIdNumber = formatEIN(initialTaxIdNumber);
    }
    this.state = {
      ...getPayeeErrorInitialState.bind(this)({
        tax_id_type: initialTaxIdType,
        tax_id_number: initialTaxIdNumber,
      }),
    };

    bindAll(this);
  }

  componentDidUpdate(prevProps, prevState) {
    checkErrored.bind(this)();
    if (prevState.errored !== this.state.errored || !this.state.canUpdateParentErrorState) {
      return updateParentErrorState.bind(this)();
    }
  }

  handleTaxIdTypeChange(ev) {
    const taxIdType = ev.target.value;
    const { tax_id_number } = this.state;
    let newTaxIdNumber;

    if (taxIdType === 'ssn') {
      newTaxIdNumber = formatSSN(tax_id_number);
    } else if (taxIdType === 'ein') {
      newTaxIdNumber = formatEIN(tax_id_number);
    } else {
      newTaxIdNumber = '';
    }

    this.setState(
      {
        tax_id_type: taxIdType,
        tax_id_number: newTaxIdNumber,
      },
      this.validate,
    );
  }

  handleTaxIdNumberChange(ev) {
    ev.preventDefault();
    const { value } = ev.target;
    const idType = this.state.tax_id_type;
    let formattedValue = value;
    if (idType) {
      formattedValue = value.replace(/-/g, '');
    }
    if (/^\d+$/.test(formattedValue) || formattedValue === '') {
      if (idType === 'ssn') {
        formattedValue = formatSSN(value);
      } else if (idType === 'ein') {
        formattedValue = formatEIN(value);
      }
      this.setState({ tax_id_number: formattedValue });
    }
  }

  validate() {
    const rawValue = this.state.tax_id_number.replace(/-/g, '');
    if (this.props.shouldValidate && rawValue.length > 0) {
      if (rawValue.length !== 9 || !this.state.tax_id_type) {
        return addError.bind(this)({
          invalidLength: 'Tax ID Number must be 9 digits and Tax ID Type is required',
        });
      }
    }
    return removeError.bind(this)('invalidLength');
  }

  render() {
    let inputClassName = 'new-form__data ';
    if (this.state.errored) inputClassName += 'validate-error';

    return (
      <div>
        <div className="new-form-field">
          <div className="new-form__label">
            <label htmlFor="payee_tax_id_type">
              Tax ID Type{' '}
              {this.state.tax_id_number ? <span style={{ color: PALETTE.red }}>*</span> : null}
            </label>
          </div>
          <div className={inputClassName}>
            <select
              className="form-control"
              id="payee_tax_id_type"
              name="taxIdType"
              onChange={this.handleTaxIdTypeChange}
              required
              type="select"
              value={this.state.tax_id_type}
            >
              <option value="">Select Tax ID Type</option>
              <option value="ssn">SSN</option>
              <option value="ein">EIN</option>
            </select>
          </div>
        </div>
        <div className="new-form-field">
          <div className="new-form__label">
            <label htmlFor="payee_tax_id_number">Tax ID Number</label>
          </div>
          <div className={inputClassName}>
            <input
              className="form-control"
              id="payee_tax_id_number"
              name="taxIdNumber"
              onBlur={this.validate}
              onChange={this.handleTaxIdNumberChange}
              type="text"
              value={this.state.tax_id_number}
            />
            <ul className="new-form__error">{listErrors.bind(this)()}</ul>
          </div>
        </div>
      </div>
    );
  }
}

PayeeTaxIdInput.propTypes = {
  taxIdNumber: PropTypes.string,
  taxIdType: PropTypes.string,
  // These are a hack we needed for removing a mix-in. These props are inspected by a Store that in bound to this component.
  // eslint-disable-next-line react/no-unused-prop-types
  addError: PropTypes.func,
  // eslint-disable-next-line react/no-unused-prop-types
  removeError: PropTypes.func,
  // eslint-disable-next-line react/no-unused-prop-types
  parentError: PropTypes.object,
  shouldValidate: PropTypes.bool,
};

PayeeTaxIdInput.defaultProps = {
  possibleErrors: {},
};
